import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=e4db4eca&"
import script from "./ranking.vue?vue&type=script&lang=ts&"
export * from "./ranking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports